import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  const formatViews = (v: number): string => {
    if (v >= 10000) {
      return (v / 10000).toFixed(1) + '万';
    }
    return v.toString();
  };

  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className={`relative overflow-hidden ${size === 'large' ? 'aspect-video' : 'aspect-video'}`}>
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-black/70 text-white rounded-md whitespace-nowrap">
          {video.duration}
        </span>
        {video.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-bold bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
            NEW
          </span>
        )}
        {video.isHot && !video.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-bold bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
            热门
          </span>
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(video.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500"></i>
            {video.rating}
          </span>
          <span className="ml-auto text-foreground-400">{video.date}</span>
        </div>
      </div>
    </Link>
  );
}